import { useEffect, useState } from "react";

const useSearch = (value, delay = 500) => {
  const [data, setData] = useState(value);

  useEffect(() => {
    const searchHandler = setTimeout(() => {
      setData(value);
    }, delay);

    return () => clearTimeout(searchHandler);
  }, [value, delay]);

  return data;
};

export default useSearch;
